export const messages = {
  en: {
    reportFeeDetail: {
      search: {
        title: 'Search Conditions',
        startDate: 'Start Date',
        endDate: 'End Date',
        objName: 'Room No/Contract/Car No',
        ownerName: 'Owner Name',
        link: 'Owner Phone',
        community: 'Community'
      },
      placeholder: {
        startDate: 'Please select start date',
        endDate: 'Please select end date',
        objName: 'Please enter room no/contract name/car no',
        ownerName: 'Please enter owner name',
        link: 'Please enter owner phone',
        community: 'Please select community'
      },
      hide: 'Hide',
      more: 'More',
      tabs: {
        room: 'Room Fee Details',
        owner: 'Owner Fee Details',
        contract: 'Contract Fee Details',
        car: 'Car Fee Details'
      }
    },
    reportFeeDetailRoom: {
      all: 'All',
      room: 'Room',
      owner: 'Owner',
      oweFee: 'Owe Fee',
      receivedFee: 'Received Fee',
      owe: ' (Owe)',
      received: ' (Received)'
    },
    reportFeeDetailOwner: {
      owner: 'Owner',
      room: 'Room',
      oweFee: 'Owe Fee',
      receivedFee: 'Received Fee',
      owe: ' (Owe)',
      received: ' (Received)'
    },
    reportFeeDetailContract: {
      contract: 'Contract',
      owner: 'Owner',
      oweFee: 'Owe Fee',
      receivedFee: 'Received Fee',
      owe: ' (Owe)',
      received: ' (Received)'
    },
    reportFeeDetailCar: {
      car: 'Car',
      owner: 'Owner',
      oweFee: 'Owe Fee',
      receivedFee: 'Received Fee',
      owe: ' (Owe)',
      received: ' (Received)'
    }
  },
  zh: {
    reportFeeDetail: {
      search: {
        title: '查询条件',
        startDate: '开始日期',
        endDate: '结束日期',
        objName: '房屋编号/合同/车牌号',
        ownerName: '业主名称',
        link: '业主手机号',
        community: '小区'
      },
      placeholder: {
        startDate: '请选择开始日期',
        endDate: '请选择结束日期',
        objName: '请输入房屋编号/合同名称/车牌号',
        ownerName: '请输入业主名称',
        link: '请输入业主手机号',
        community: '请选择小区'
      },
      hide: '隐藏',
      more: '更多',
      tabs: {
        room: '房屋费用明细',
        owner: '业主费用明细',
        contract: '合同费用明细',
        car: '车辆费用明细'
      }
    },
    reportFeeDetailRoom: {
      all: '全部',
      room: '房屋',
      owner: '业主',
      oweFee: '欠费',
      receivedFee: '实收',
      owe: ' (欠费)',
      received: ' (实收)'
    },
    reportFeeDetailOwner: {
      owner: '业主',
      room: '房屋',
      oweFee: '欠费',
      receivedFee: '实收',
      owe: ' (欠费)',
      received: ' (实收)'
    },
    reportFeeDetailContract: {
      contract: '合同',
      owner: '业主',
      oweFee: '欠费',
      receivedFee: '实收',
      owe: ' (欠费)',
      received: ' (实收)'
    },
    reportFeeDetailCar: {
      car: '车辆',
      owner: '业主',
      oweFee: '欠费',
      receivedFee: '实收',
owe: ' (欠費)',
      received: ' (實收)'
    }
  },
  'zh-TW': {
    reportFeeDetail: {
      search: {
        title: '查詢條件',
        startDate: '開始日期',
        endDate: '結束日期',
        objName: '房屋編號/合同/車牌號',
        ownerName: '業主名稱',
        link: '業主手機號',
        community: '小區'
      },
      placeholder: {
        startDate: '請選擇開始日期',
        endDate: '請選擇結束日期',
        objName: '請輸入房屋編號/合同名稱/車牌號',
        ownerName: '請輸入業主名稱',
        link: '請輸入業主手機號',
        community: '請選擇小區'
      },
      hide: '隱藏',
      more: '更多',
      tabs: {
        room: '房屋費用明細',
        owner: '業主費用明細',
        contract: '合同費用明細',
        car: '車輛費用明細'
      }
    },
    reportFeeDetailRoom: {
      all: '全部',
      room: '房屋',
      owner: '業主',
      oweFee: '欠費',
      receivedFee: '實收',
      owe: ' (欠費)',
      received: ' (實收)'
    },
    reportFeeDetailOwner: {
      owner: '業主',
      room: '房屋',
      oweFee: '欠費',
      receivedFee: '實收',
      owe: ' (欠費)',
      received: ' (實收)'
    },
    reportFeeDetailContract: {
      contract: '合同',
      owner: '業主',
      oweFee: '欠費',
      receivedFee: '實收',
      owe: ' (欠費)',
      received: ' (實收)'
    },
    reportFeeDetailCar: {
      car: '車輛',
      owner: '業主',
      oweFee: '欠費',
      receivedFee: '實收',
      owe: ' (欠費)',
      received: ' (實收)'
    }
  }
}